import axiosClient from './axiosClient'

export const getProcessStatus = (processId) => {
    return axiosClient.get(`/process/${processId}`);
};  